import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./stiluri/Antet.css";
import lupaImg from "./imagini/lupa.png";
import adaugareImg from "./imagini/adaugare.png";
import ReportsImg from "./imagini/ReportsImg.png";
import AccountManagementImg from "./imagini/AccountManagementImg.png";
import ProfilImg from "./imagini/ProfilImg.png";
import AccountSettingImg from "./imagini/AccountSettingImg.png";
import LogoutImg from "./imagini/LogoutImg.png";
import CeasImg from "./imagini/CeasImg.png";
import useAuthInfo from "../hooks/useAuthInfo";

const Antet = ({ onLogout }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // 👈 i18n
  const { userFullName, userEmail, userRole } = useAuthInfo();

  const [currentTime, setCurrentTime] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [showRoleMenu, setShowRoleMenu] = useState(false);

  const roleMenuRef = useRef(null);

  const toggleRoleMenu = () => {
    setShowRoleMenu((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (roleMenuRef.current && !roleMenuRef.current.contains(event.target)) {
        setShowRoleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function updateTimeAndDate() {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString("ro-RO", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
      setCurrentDate(
        now.toLocaleDateString("ro-RO", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })
      );
    }

    updateTimeAndDate();
    const interval = setInterval(updateTimeAndDate, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleCautaBeneficiar = () => navigate("/dashboard");
  const handleAddBeneficiar = () => navigate("/adauga-beneficiar");
  const handleAdministrareUtilizatori = () => navigate("/administrare-utilizatori");

  return (
    <header className="antet">
      <button className="btnantet btn-primary title-button" onClick={handleCautaBeneficiar}>
        {t("welcome_title")}
      </button>

      <nav className="meniu-navigare">
        <button className="btnantet btn-primary search-button" onClick={handleCautaBeneficiar}>
          <img src={lupaImg} alt="Căutare" style={{ width: "17px", marginRight: "8px", marginBottom: "5px" }} />
          {t("search")}
        </button>

        <button className="btnantet btn-primary add-beneficiar-button" onClick={handleAddBeneficiar}>
          <img src={adaugareImg} alt="Adaugare" style={{ width: "18px", marginRight: "8px", marginBottom: "5px" }} />
          {t("add_beneficiary")}
        </button>

        {userRole === "admin" && (
          <button className="btnantet btn-primary admin-utilizatori-button" onClick={handleAdministrareUtilizatori}>
            <img src={AccountManagementImg} alt="Administrare Utilizatori" className="icon account-management-img" />
            {t("admin_users")}
          </button>
        )}

        <button className="btnantet btn-primary rapoarte-button" onClick={() => navigate("/rapoarte")}>
          <img src={ReportsImg} alt="Rapoarte" className="icon reports-img" />
          {t("reports")}
        </button>

        <button className="btnantet btn-primary logout-button" onClick={onLogout}>
          <img src={LogoutImg} alt="Logout" className="icon logout-img" />
          {t("logout")}
        </button>
      </nav>

      <div className="date-ora">
        <span className="current-time">{currentTime}</span>
        <img src={CeasImg} alt="Ceas Icon" className="icon ceas-img" />
        <span className="current-date">{currentDate}</span>
      </div>

      <div className="user-email" style={{ position: "relative" }} ref={roleMenuRef}>
        <span className="user-name" onClick={toggleRoleMenu} style={{ cursor: "pointer" }}>
          {userFullName || userEmail || "Se încarcă..."}
        </span>

        {showRoleMenu && (
          <div className="role-menu">
            <span className="role-text" style={{ color: "white" }}>
              <strong style={{ color: "white" }}>Rol:</strong>{" "}
              <span style={{ color: "white" }}>{userRole}</span>
            </span>

            <button
              className="dropdown-item"
              onClick={() => navigate("/profil")}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px", background: "none", border: "none", cursor: "pointer", width: "100%" }}
            >
              <img src={ProfilImg} alt="Profil" className="icon" style={{ width: "18px" }} />
              {t("profile")}
            </button>

            <button
              className="btnantet btn-primary setari-button"
              onClick={() => navigate("/setari")}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px", background: "none", border: "none", cursor: "pointer", width: "100%" }}
            >
              <img src={AccountSettingImg} alt="Setări" className="icon account-setting-img" />
              {t("settings")}
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Antet;